import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hornbill': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M76.4 370.3c0.2 1.4 0.3 3.6 0.3 5 0 20.9-16.9 37.8-37.8 37.8s-37.8-16.9-37.8-37.8c0-20.9 16.9-37.8 37.8-37.8 1.5 0 3.9 0.2 5.4 0.4-78.3-111.3 52-190.5 52-190.5-5.9 43-8.2 91.2-8.2 91.2-67.3 41.5 0.9 64.1 39.8 72.9 18.6 50.7 77.6 91.9 131.7 91.9 1.9 0 3.8-0.2 5.7-0.3l0.1 18.9c-99.2 1.4-158.7-29.1-188.9-51.6zM184.4 42.6c109.8-73.9 187.6 54.1 187.6 54.1-43-5.9-91.2-8.2-91.2-8.2-43.1-70-65.8 6.6-73.8 44.3-48.5 19.6-87.9 77.9-87.9 130.1 0 0.9 0.1 1.8 0.1 2.7l-21.8 0.2c-1.4-100.4 29.9-160.1 52.4-190-0.8 0.1-2.2 0.1-3.1 0.1-20.9 0-38-17-38-37.9 0-20.9 17-38 38-38 13.2 0 28.5 9.7 34.2 21.6 2 4.3 3.7 11.5 3.7 16.3 0 1.4-0.1 3.5-0.3 4.9zM488.6 176.8c-4.2 2-11.4 3.6-16.1 3.6-0.9 0-2.3-0.1-3.2-0.1 84.5 113.5-49 194.6-49 194.6 5.9-43 8.2-91.2 8.2-91.2 66.6-41 0.6-63.5-38.5-72.5-19.4-49-77.8-88.7-130.5-88.8-2.8 0-5.4 0.3-8.1 0.4l-0.1-22.5c93.6-1.3 151.7 25.8 183.4 47.7-0.2-1.5-0.4-4-0.4-5.6 0-20.9 17-37.9 37.9-37.9 20.9 0 37.9 17 37.9 37.9 0 13.2-9.7 28.6-21.6 34.3zM374.1 436.2v0.1c0.1 0 0.2 0 0.3 0 20.9 0 37.9 17 37.9 37.9s-17 37.9-37.9 37.9c-13.2 0-28.5-9.7-34.2-21.6-1.8-3.7-3.4-9.9-3.6-14-112 80.3-191.9-51-191.9-51 43.1 5.9 91.2 8.2 91.2 8.2 41.3 67.2 63.9-0.5 72.8-39.5 50.4-18.8 91.4-77.7 91.4-131.4 0-2.1-0.2-4.1-0.3-6.2l19.5-0.1c1.3 90-23.7 147.2-45.1 179.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hornbill.js
// module id = 880
// module chunks = 0